import { Timer } from "./Time/Timer";


type ease = (k: number) => number;



export class PopupMessageType {
    /**
    * (RO) Vzdalenost, kterou ma zprava urazit
    */
    get moveDistance(): pc.Vec3 { return this._moveDistance; }
    private _moveDistance: pc.Vec3;
    /**
    * (RO) Doba, za kterou ma zprava vzdalenost urazit
    */
    get moveTime(): number { return this._moveTime; }
    private _moveTime: number;
    /**
    * (RO) Ease funce, ktera se ma pouzit pro presun
    */
    get moveEase(): ease { return this._moveEase; }
    private _moveEase: ease;
    /**
    * (RO) Prodleva, nez se zacne menit alfa
    */
    get alphaDelay(): number { return this._alphaDelay; }
    private _alphaDelay: number;
    /**
    * (RO) Cas, po ktery se ma menit alfa
    */
    get alphaTime(): number { return this._alphaTime; }
    private _alphaTime: number;
    /**
    * (RO) Ease funkce pro zmenu alfy
    */
    get alphaEase(): ease { return this._alphaEase; }
    private _alphaEase: ease;

    //---------------------------------------------------------------------
    /**
     * Konstruktor
     * @param moveDistance Vzdalenost, kterou ma zprava urazit na jednotlivych osach
     * @param moveTime Doba, za kterou ma zprava vzdalenost urazit (ms)
     * @param moveEase Ease funce, ktera se ma pouzit pro presun
     * @param alphaDelay Prodleva, nez se zacne menit alfa (ms). Pokud  nezadano, tak se alfa nepocita.
     * @param alphaTime Cas, po ktery se ma menit alfa (ms)
     * @param alphaEase Ease funkce pro zmenu alfy
     */
    //---------------------------------------------------------------------
    constructor(moveDistance: pc.Vec3, moveTime: number, moveEase: ease, alphaDelay: number = -1, alphaTime?: number, alphaEase?: ease) {
        this._moveDistance = moveDistance;
        this._moveTime = moveTime;
        this._moveEase = moveEase;
        this._alphaDelay = alphaDelay;
        this._alphaTime = alphaTime;
        this._alphaEase = alphaEase;
    }
}



export abstract class PopupMessageBase {
    protected _timer: Timer;
    protected _type: PopupMessageType;

    protected _startPos: pc.Vec3;
    protected _startTime: number;

    /**
     * Aktualni pozice v zivote zpravy (0 az 1). Pokud -1, tak je zprava neaktivni.
     */
    protected _progress: number;

    private static _tmpVec3: pc.Vec3 = new pc.Vec3();

    //---------------------------------------------------------------------
    //---------------------------------------------------------------------
    constructor() {
        this._startPos = new pc.Vec3();
        this._progress = -1;
    }

    //---------------------------------------------------------------------
    /**
     * Aktualizace
     * @return True, pokud je zprava stale aktivni
     */
    //---------------------------------------------------------------------
    update(): boolean {
        if (this._progress < 0)
            return false;

        let time = this._timer.time - this._startTime;
        let completeMask = 0;

        // Pohyb
        let progress = time / this._type.moveTime;

        if (progress >= 1) {
            progress = 1;
            completeMask |= 1;
        }

        this._progress = progress;

        let progressEased = this._type.moveEase(progress);
        let moveDis = this._type.moveDistance;
        let pos = PopupMessageBase._tmpVec3;

        pos.x = this._startPos.x + moveDis.x * progressEased;
        pos.y = this._startPos.y + moveDis.y * progressEased;
        pos.z = this._startPos.z + moveDis.z * progressEased;

        // Alfa
        let opacity = 1;

        if (this._type.alphaDelay >= 0) {
            if (time > this._type.alphaDelay) {
                progress = (time - this._type.alphaDelay) / this._type.alphaTime;

                if (progress >= 1) {
                    progress = 1;
                    completeMask |= 2;
                }

                opacity = 1 - this._type.alphaEase(progress);
            }
        }
        else {
            completeMask |= 2;
        }

        // Aktualizovat kontejner
        this.updateContainer(pos, opacity);

        if (completeMask == 3) {
            this.release();
            return false;
        }

        return true;
    }

    //---------------------------------------------------------------------
    //---------------------------------------------------------------------
    protected abstract updateContainer(pos: pc.Vec3, opacity: number): void;

    //---------------------------------------------------------------------
    //---------------------------------------------------------------------
    protected showMessage(x: number, y: number, z: number, type: PopupMessageType, timer: Timer): void {
        this._timer = timer;
        this._type = type;
        this._progress = 0;

        this._startPos.set(x, y, z);
        this._startTime = timer.time;

        this.updateContainer(this._startPos, 1);
    }

    //---------------------------------------------------------------------
    //---------------------------------------------------------------------
    release(): void {
        this._progress = -1;
    }
}
